// Generated by ReScript, PLEASE EDIT WITH CARE

import * as PartnerContentHelper from "./PartnerContentHelper.bs.js";

function getContent(message_text, vehicle_category, geo_region) {
  vehicle_category !== 0;
  return {
          title_text: "Cancellation score",
          learn_more_text: "Learn more",
          info_btn_details: {
            video_url: undefined,
            question: "How cancellation score is calculated ?",
            answer: "Cancellation score is calculated based on the total cancellations attributable to driver in the last 30 orders accepted by you."
          },
          learn_more_btn_details: [
            {
              video_url: PartnerContentHelper.getV2LearnMoreVid(geo_region),
              question: "What is cancellation score and why it is important ?",
              answer: ""
            },
            {
              video_url: undefined,
              question: "When will i get suspended?",
              answer: "Whenever you cross a level you will be suspended for the corresponding duration."
            },
            {
              video_url: undefined,
              question: "What is the suspension duration for every levels ?",
              answer: "Duration of suspension at each level can be checked in suspension guide."
            },
            {
              video_url: undefined,
              question: "Why i am not able to see cancellation score?",
              answer: "Cancellation score is calculated for those partners who have a minimum of 30 orders accepted in the recent months."
            }
          ],
          locked_score_msg: "Accept more orders to unlock cancellation score.",
          message_text: message_text,
          suspension_guide_text: "Suspension guide",
          suspension_guide_table_details: {
            cancellation_score_text: "Cancellation score",
            suspension_days_text: "Suspension days"
          }
        };
}

export {
  getContent ,
  
}
/* No side effect */
